import Vue from "vue";
import Vuex from "vuex";
import {createStore} from "@/store/store";

export * from "./state";
export * from "./store";

Vue.use(Vuex)
export default createStore
